__turbopack_context__.v({
  "baseButton": "Button-module-scss-module__YsLvQG__baseButton",
  "disabled": "Button-module-scss-module__YsLvQG__disabled",
  "iconButton": "Button-module-scss-module__YsLvQG__iconButton",
  "primary": "Button-module-scss-module__YsLvQG__primary" + " " + "Button-module-scss-module__YsLvQG__baseButton",
  "secondary": "Button-module-scss-module__YsLvQG__secondary" + " " + "Button-module-scss-module__YsLvQG__baseButton",
  "small": "Button-module-scss-module__YsLvQG__small",
  "tertiary": "Button-module-scss-module__YsLvQG__tertiary" + " " + "Button-module-scss-module__YsLvQG__baseButton",
  "unstyled": "Button-module-scss-module__YsLvQG__unstyled",
});
